import { makeAutoObservable, runInAction } from 'mobx';

import { utils } from "./Utils";

type AlertType = "warning" | "error" | "success"

export class AlertController {
  alertVisible = false;
  mainText = "";
  secondaryText: string | Array<string> | null = ""
  alertType: AlertType = "warning"

  getAlertColor = () => {
    switch (this.alertType) {
      case "warning": return "amber"
      case "error": return "red"
      case "success": return "green"
    }
  }

  getAlertTextColor = () => {
    switch (this.alertType) {
      case "warning": return "black"
      case "error":
      case "success": return "white"
    }
  }

  displayAlert = (mainText: string, secondaryText: string | Array<string> | null, alertType: AlertType, timeToLive?: number) => {
    runInAction(() => {
      this.mainText = mainText
      this.secondaryText = secondaryText
      this.alertType = alertType
      this.alertVisible = true
    })

		if (timeToLive) {
      void utils.callbackIn(timeToLive, () => runInAction(() => this.alertVisible = false))
    }
  }

  hideAlert = () => {
    runInAction(() => this.alertVisible = false)
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const alertController = new AlertController();